import React from 'react';
import { SparkleIcon } from './icons/SparkleIcon';
import { ArrowRightIcon } from './icons/ArrowRightIcon';
import SEO from './SEO';

interface WelcomeScreenProps {
  onStartQuiz: () => void;
  onLoginClick: () => void;
}

const WelcomeScreen: React.FC<WelcomeScreenProps> = ({ onStartQuiz, onLoginClick }) => {
  return (
    <div className="flex flex-col items-center">
      <SEO 
        title="ForgivePath: Student Loan Forgiveness Maximizer | Eligibility Check"
        description="Stop guessing. Calculate your student loan forgiveness eligibility instantly."
        url="https://www.forgivepath.com/"
      />
      
      <div className="text-center mb-16">
        <div className="inline-flex items-center gap-2 bg-green-50 text-green-700 text-[10px] font-black uppercase tracking-widest px-4 py-2 rounded-full mb-6 shadow-sm border border-green-100">
          <SparkleIcon className="w-4 h-4 text-green-500" />
          We Handle Everything For You
        </div>
        <h1 className="text-5xl md:text-8xl font-black tracking-tighter mb-6 max-w-5xl leading-none text-gray-900">
          Your Student Loan Forgiveness, <span className="text-green-500">Simplified</span>
        </h1>
        <p className="text-lg md:text-xl text-gray-600 max-w-2xl mx-auto mb-10 font-medium">
          No need to compare programs or guess which one is right. We automatically apply to <strong>every program you qualify for</strong> to maximize your savings.
        </p>
        
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4 mb-8">
          <button 
            onClick={onStartQuiz} 
            className="bg-green-500 hover:bg-green-600 text-white font-black text-lg py-5 px-12 rounded-2xl shadow-xl shadow-green-500/20 transition-all duration-300 transform hover:scale-105 flex items-center gap-3"
          >
            Check My Eligibility
            <ArrowRightIcon className="w-6 h-6" />
          </button>
        </div>

         <p className="text-xs font-bold text-gray-400">
              Already have an account?{' '}
              <button onClick={onLoginClick} className="text-blue-600 hover:underline">
                  Log In
              </button>
          </p>
      </div>
    </div>
  );
};

export default WelcomeScreen;